var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcShirt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fillRule: "nonzero",
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FCF1F2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.946 11.929l-6 6.015-6.362-6.277-12.81.665L7.756 16.3l-1.667 1.645-6-6.015S2.4 7.837 5.639 4.766c.301-.286.61-.562.925-.826C8.83 2.05 11.52.788 14.041.092L14.08.08c.654.635 2.393 1.089 4.437 1.089 2.043 0 3.783-.454 4.437-1.089l.039.012c2.52.696 5.211 1.958 7.477 3.848.316.264.624.54.924.826 3.239 3.07 5.552 7.163 5.552 7.163z",
    fill: "#F96167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.447 4.686A7.092 7.092 0 0 0 29.33 9.73v22.136H7.808V9.73a7.092 7.092 0 0 0-2.116-5.044c.3-.286.609-.563.924-.826C8.882 1.97 11.572.708 14.094.01L14.132 0c.655.634 2.393 1.088 4.437 1.088 2.043 0 3.783-.454 4.438-1.088l.038.011c2.52.697 5.212 1.958 7.477 3.849.316.263.624.54.925.826z",
    fill: "#FFB5B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.182.011v1.311c0 1.22-.501 2.325-1.311 3.124a4.491 4.491 0 0 1-3.165 1.294c-2.473 0-4.475-1.978-4.475-4.418V.012c.013-.005.025-.01.038-.012.654.634 2.393 1.088 4.437 1.088 2.043 0 3.783-.454 4.437-1.088l.04.011z",
    fill: "#F96167"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F96167",
    fillRule: "nonzero",
    cx: 18.856,
    cy: 13.867,
    rx: 3.202,
    ry: 3.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShirt);
export default __webpack_public_path__ + "static/media/ic_shirt.61f1405ba15ae45e209d31d241536886.svg";
export { ForwardRef as ReactComponent };